declare global {
  interface Window {
    grecaptcha: any;
  }
}

const createRecaptchaActionName = () => {
  const [brand, , lang] = window.location.pathname.replace(/^\/?|\/?$/g, '').split('/');

  return `send_from_${brand}_${lang}`.replace(/[^a-zA-Z0-9_]/g, '_');
};

export const initRecaptcha = (key) => {
  const head = document.getElementsByTagName('head')[0];
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = `https://www.google.com/recaptcha/api.js?render=${key}`;
  head.appendChild(script);
};

export const getRecaptchaToken = async (key) => {
  const { grecaptcha } = window;
  if (!(grecaptcha && key)) return;
  await new Promise((resolve) => {
    grecaptcha.ready(resolve);
  });
  const token = await grecaptcha.execute(key, { action: createRecaptchaActionName() });

  return token;
};
